import React, { useEffect } from "react";
import ServiceTemplate from "../components/ServiceTemplate";

import solarBanner from "../images/solar.jpg";
import solarBig from "../images/solar2.jpg";
import solarCollage from "../images/solargrid.png";

import {
  FaMobileAlt,
  FaRupeeSign,
  FaLeaf,
  FaTools,
  FaShieldAlt
} from "react-icons/fa";

export default function Solar() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

 const sidebar = [
  {
    title: "Real-Time Solar Monitoring App",
    icon: FaMobileAlt,
  },
  {
    title: "Lower Electricity Bills",
    icon: FaRupeeSign,
  },
  {
    title: "Improves School Sustainability Rating",
    icon: FaLeaf,
  },
  {
    title: "3–7 Day Installation",
    icon: FaTools,
  },
  {
    title: "Warranty & Support",
    icon: FaShieldAlt,
  },
];

  const features = [
    "Site Survey — Precise Yield Estimates",
    "Tata Solar Power Panels & BIS Tier-1 Quality",
    "Neat Cabling & Safety-First Installation",
    "Single-Line Diagram & Layout",
    "Warranty & After-Sales Support",
  ];

  return (
    <ServiceTemplate
      title="Solar Services"
      bannerImage={solarBanner}
      bigImage={solarBig}
      collageImage={solarCollage}
      sidebarItems={sidebar}
      features={features}
    />
  );
}
